/**
 * Module dependencies.
 */

import HeroBackgroundSvg from 'src/assets/landingpage/hero-background.svg';
import styled from 'styled-components';

/**
 * `Background` styled component.
 */

const Background = styled.div`
  align-items: center;
  bottom: 40px;
  display: flex;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateY(-100%);
  transition: transform 0.1s ease-out;
  width: 100vw;
  z-index: -1;
`;

/**
 * `BackgroundContainer` styled component.
 */

const BackgroundContainer = styled.div`
  bottom: 0;
  display: block;
  height: auto;
  min-width: 100vw;
  object-fit: cover;
  position: absolute;
  width: 100%;
`;

/**
 * Export `HeroBackground` component.
 */

export function HeroBackground() {
  return (
    <Background data-name={'background'} id={'hero-background'}>
      <BackgroundContainer>
        <HeroBackgroundSvg />
      </BackgroundContainer>
    </Background>
  );
}
